import axios from 'axios'
import {CertificatesQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL;

const getCertificates = (filter: any): Promise<CertificatesQueryResponse> => {

    return axios.post(`${API_URL}/SearchCertificateServlet`, filter)
    .then((res) => {
        // conform output to { data, payload } object.
        return {data : res.data && res.data.searchCertificateModels ? res.data.searchCertificateModels : [] , payload : {}};
    })
    .catch((err) => {
        return {data: [], payload: {}}
    })         
}


const getCertificateById = (id : number) => {
    // get certificate record
    return axios.post<any>(`${API_URL}/GetCertificateServlet`,  id, { headers: { "Content-Type": "text/plain" }} )
    .then((res) => {        
        return res.data;
    })        
}


export {getCertificates, getCertificateById}
